import {TextField} from "@material-ui/core";
import {Button} from "react-bootstrap";
import {useState} from "react";
import {download_file} from "../files";
import Message from "../message";

function FileStatus() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`

    const [file_name, setFile_name] = useState('')
    const [status_file, setStatus_file] = useState("");
    const [should_download, setShould_download] = useState(false);

    const download_file_status = async () => {
        await download_file(file_name)
        setShould_download(false);
        setStatus_file("")
    }

    const file_status = async () => {
        setShould_download(false)
        setStatus_file("")

        if (file_name === '') {
            setStatus_file("Enter file name!")
        } else {
            try {
                const file_response = await fetch(apiServer + 'api/file/file_length/' + file_name);
                const fileResponse = await file_response.json();
                console.log(fileResponse);
                if (fileResponse !== undefined) {
                    setStatus_file(fileResponse)
                    if (Number.isInteger(fileResponse)) {
                        setShould_download(true)
                    }
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    return (
        <div style={{marginTop: "20px"}}>
            <TextField style={{width: '100%'}} value={file_name} onChange={(e) => setFile_name(e.target.value)}
                       id="outlined-basic" label="File name" variant="filled"/>
            <Button variant="primary" style={{marginTop: "10px"}} onClick={() => file_status()}>Submit</Button>
            {should_download ? <Button variant="secondary" style={{marginTop: "10px", marginLeft: "10px"}}
                                       onClick={() => download_file_status()}>Download</Button> : <div/>}
            {Message(status_file, setStatus_file)}
        </div>
    )
}

export default FileStatus